export default __webpack_public_path__ + "static/media/casper.fb71b687.png";